    import * as React from 'react'
    import { Slot } from '@radix-ui/react-slot'
    import { cva } from 'class-variance-authority'
    import { cn } from '../../lib/utils.js'
    import '../../Styles/Button.css'
    import PropTypes from 'prop-types'
    import TouchRipple from '@mui/material/ButtonBase/TouchRipple'

    const buttonVariants = cva(
        'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        {
            variants: {
                variant: {
                    default:
            'bg-primary text-primary-foreground shadow hover:bg-primary/90',
                    destructive:
            'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90',
                    outline:
            'border border-primary bg-background text-primary shadow-sm hover:bg-accent hover:text-primary/50 hover:border-primary/50',
                    secondary:
            'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80',
                    ghost: 'hover:bg-accent hover:text-accent-foreground',
                    link: 'text-primary underline-offset-4 hover:underline',
                    dateInput: 'border border-input bg-background focus:ring-primary rounded-lg h-9 flex shadow-sm'
                },
                size: {
                    default: 'h-9 px-4 py-2',
                    sm: 'h-8 rounded-md px-3 text-xs',
                    lg: 'h-10 rounded-md px-8',
                    icon: 'h-9 w-9'
                }
            },
            defaultVariants: {
                variant: 'default',
                size: 'default'
            }
        }
    )

    const Button = React.forwardRef(({ className, variant, size, fontSize, asChild = false, ...props }, ref) => {
        const Comp = asChild ? Slot : 'button'
        const rippleRef = React.useRef(null)

        const onRippleStart = (e) => {
            rippleRef.current?.start(e)
        }

        const onRippleStop = (e) => {
            rippleRef.current?.stop(e)
        }
        return (
            (<Comp
                className={cn(buttonVariants({ variant, size, className }), ` ${variant === 'dateInput' ? '' : 'grc-btn'} ${variant || 'default'} !text-menu min-w-[100px]`)}
                onMouseDown={onRippleStart}
                style={{ fontSize }}
                onMouseUp={onRippleStop}
                ref={ref}
                {...props} >
                {props.children}
                {variant !== 'dateInput' && <TouchRipple ref={rippleRef} center={false} />}
            </Comp>)
        )
    })
    Button.displayName = 'Button'

    Button.propTypes = {
        className: PropTypes.string,
        variant: PropTypes.string,
        size: PropTypes.string,
        asChild: PropTypes.bool
    }

    export { Button, buttonVariants }
